module.exports = __webpack_public_path__ + "static/media/swimming-diving.cfb6c67b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/swimming-diving.jpg
// module id = 695
// module chunks = 0